import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FilterSelectComponent } from './filter-select.component';
import {
    FilterSelectFilterTemplateDirective,
    FilterSelectFooterTemplateDirective,
    FilterSelectItemTemplateDirective,
    FilterSelectSelectedItemTemplateDirective,
} from './filter-select-templates.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ScrollingModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
    ],
    declarations: [
        FilterSelectComponent,
        FilterSelectItemTemplateDirective,
        FilterSelectSelectedItemTemplateDirective,
        FilterSelectFilterTemplateDirective,
        FilterSelectFooterTemplateDirective,
    ],
    exports: [
        FilterSelectComponent,
        FilterSelectItemTemplateDirective,
        FilterSelectSelectedItemTemplateDirective,
        FilterSelectFilterTemplateDirective,
        FilterSelectFooterTemplateDirective,
    ],
})
export class UiFilterSelectModule {}

